'use strict';

Odigeo.defineWidget('sessionrecorder', require('./sessionrecorder_widget'));
